const Moment = require("moment");

const GlobalConstants = require("../GlobalConstants.js");
const FileUploadActions = require("../actions/FileUploadActions.js");

const FileUploadReducers = {
    [FileUploadActions.Upload](prev, action) {        
        const index = prev.SelectedFiles.findIndex((f) => {
            return f.UID === action.File.UID;
        });

        const files = [
            ...prev.SelectedFiles.slice(0, index),
            Object.assign({}, action.File, {
                IsUploading: true,
                UploadStartedAt: Moment()
            }),
            ...prev.SelectedFiles.slice(index + 1)
        ];

        return Object.assign({}, prev, {
            Upload: {   
                IsWorking: true
            },
            SelectedFiles: files
        });
    },
    [FileUploadActions.Uploaded](prev, action) {        
        const index = prev.SelectedFiles.findIndex((f) => {
            return f.UID === action.File.UID;
        });

        const files = [
            ...prev.SelectedFiles.slice(0, index),
            ...prev.SelectedFiles.slice(index +1)
        ];
        
        const mode = files.length
            ? prev.Mode
            : GlobalConstants.Modes.History;

        const isWorking = files.some((f) => f.IsUploading);
        const hasErrors = files.some((f) => typeof(f.UploadError) !== "undefined");

        return Object.assign({}, prev, {
            Mode: mode,
            Upload: {
                IsWorking: isWorking
            },
            SelectedFiles: files
        });
    },
    [FileUploadActions.UploadErrored](prev, action) {
        const index = prev.SelectedFiles.findIndex((f) => {
            return f.UID === action.File.UID;
        });

        const files = [
            ...prev.SelectedFiles.slice(0, index),
            Object.assign({}, action.File, {
                IsUploading: false,
                IsInvalid: true,
                Message: "Upload failed",
                UploadError: action.Error
            }),
            ...prev.SelectedFiles.slice(index +1)
        ];

        const isWorking = files.some((f) => f.IsUploading);

        return Object.assign({}, prev, {
            Upload: {
                IsWorking: isWorking,
                HasErrors: true
            },
            SelectedFiles: files
        });
    }
};

module.exports = FileUploadReducers;


// WEBPACK FOOTER //
// ./src/reducers/FileUploadReducers.js